import { useQuery } from '@tanstack/react-query'
import { getScannerSettings } from './getScannerSettings'
import { ScannerSettingsModel } from './types'
import { SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

export const QUERY_KEY_SETTINGS_SCANNER = 'settings-scanner'

export function useQueryScannerSettings({ companyId }: { companyId: string }) {
  return useQuery<ScannerSettingsModel>({
    queryKey: [QUERY_KEY_SETTINGS_SCANNER, companyId],
    queryFn: async () => {
      const { data } = await getScannerSettings({ companyId })
      return data
    },
    ...SETTINGS_QUERY_NO_CACHE,
    enabled: !!companyId,
  })
}
